import '../marketing-tailwind.built.css'

export default {
  mounted() {
    document.documentElement.setAttribute('data-marketing-page', '1')
    document.documentElement.style.fontSize = ''
  },
  beforeDestroy() {
    document.documentElement.removeAttribute('data-marketing-page')
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('resize'))
    }
  }
}
